var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y-panel-msg"},[_c('img',{attrs:{"src":_vm.ico,"alt":""}}),_c('div',{staticClass:"msg"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"sub"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }